export enum HelpLayoutEnum {
    web = 0,
    mobile = 1,
    desktop = 2
}
